import institutionAPI from 'services/institutionAPI'

type Params = {
  costCenterId: string
}

export default async function getCostCenterOnCustomForm({ costCenterId }: Params) {
  const response = await institutionAPI({
    method: 'GET',
    url: `/citizen-portal/service/cost-center/${costCenterId}`,
  })

  return response
}
